import React from "react"
import { Row } from "antd"
import { inject, observer } from "mobx-react"
import { setCurrentApp } from "app/api/localTools"
import { withRouter } from 'react-router-dom'
import cx from "classnames"

@inject("auth") @observer
class SwitchApp extends React.Component {
  switchApp = (app) => {
    const { auth } = this.props
    setCurrentApp(app)
    if (auth.userInfo.roleType === 'research') {
      this.props.history.push(`/jab/main/research/${app}/data_manage`)
    } else {
      this.props.history.push(`/jab/main/${app}/overview`)
    }
    this.forceUpdate()
  }

  render() {
    const { auth: { apps, userInfo }, className } = this.props
    const path = window.location.pathname
    const currentApp = userInfo.roleType !== 'research' ? path.split("/")[3] : path.split("/")[4]
    return (
      <Row type="flex" align="middle" justify="center" className={className}>
        {
          userInfo.roleType === 'main' && <div
            key="preview"
            className={cx({
              "active": currentApp === 'preview',
              "cursor-p": true
            })}
            onClick={() => this.switchApp('preview')}
          >
            总览
        </div>
        }
        {
          (userInfo.roleType === 'sub' || userInfo.roleType === 'research') && (
            apps.map(app =>
              <div
                key={app}
                className={cx({
                  "active": currentApp === app,
                  "cursor-p": true
                })}
                onClick={() => this.switchApp(app)}
              >
                {app}
              </div>
            )
          )
        }
      </Row>
    )
  }
}

export default withRouter(SwitchApp)



// WEBPACK FOOTER //
// ./src/app/components/common/SwitchApp/SwitchApp.js